/**
 * @generated SignedSource<<7e1481176d3ee7d6513a56391bc619b9>>
 * @relayHash 45134008e7cf6655e850b0655eba396c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 85433a2a8517c0bbd032c987ee6020d4be5b7318949493fd8edefb15cec1200d

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GenerateSignInTokenMutationInput = {
  authRedirectPath?: string | null | undefined;
  email: string;
};
export type SignInScreenTokenFormMutation$variables = {
  input: GenerateSignInTokenMutationInput;
};
export type SignInScreenTokenFormMutation$data = {
  readonly generateSignInToken: {
    readonly __typename: string;
  };
};
export type SignInScreenTokenFormMutation = {
  response: SignInScreenTokenFormMutation$data;
  variables: SignInScreenTokenFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "generateSignInToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignInScreenTokenFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignInScreenTokenFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "85433a2a8517c0bbd032c987ee6020d4be5b7318949493fd8edefb15cec1200d",
    "metadata": {},
    "name": "SignInScreenTokenFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4c6e30d6feb1b6d494e7dd857cc165c7";

export default node;
